import api from '../api';
import type { CategoryGroup } from './lots';
import type { SearchCount } from './searchCount';

export type CategoryCountSelection = { code: string } | { section: string; group: CategoryGroup };
export interface CategoryCount extends SearchCount { key: string }

export function categoryCountKey(selection: CategoryCountSelection): string {
  return 'code' in selection ? `code:${selection.code}` : `section:${selection.group}:${selection.section}`;
}

export async function getCategoryCounts(selections: CategoryCountSelection[], signal: AbortSignal, retryFailed = false): Promise<CategoryCount[]> {
  const { data } = await api.post<{ items: CategoryCount[] }>('/lots/categories/counts', { selections, retry_failed: retryFailed }, { signal, timeout: 12000 });
  return data.items;
}
